import { Container } from '@clearcover/atlas';
import { VersionedObjectDiff } from '@clearcover/core-app-types';
import { DisplayAddress } from '@clearcover/core-app-types/dist/endpoints/getPolicy/displayAddress';
import { formatDiff } from 'Policies/components/PolicyActivities/Common/Common';
import { CardSectionInfoPairs } from 'Shared/components';
import React, { FC } from 'react';

export type AddressChangeDetailsDiff = {
  diff: VersionedObjectDiff<DisplayAddress>;
};

export const AddressChangeDetails: FC<AddressChangeDetailsDiff> = ({
  diff,
}) => {
  return (
    <div data-testid="address-change-details">
      <Container>
        <h4>Address Change</h4>
        {diff.new?.addresses.map((newAddr, index) => {
          const oldAddr = diff.old?.addresses[index];
          return (
            <CardSectionInfoPairs
              headers={[
                'Street Address',
                'City',
                'State',
                'District',
                'Postal Code',
                'Country',
              ]}
              data={[
                formatDiff(
                  `${oldAddr?.addressLine1 ?? ''} ${oldAddr?.addressLine2 ??
                    ''}`,
                  `${newAddr?.addressLine1 ?? ''} ${newAddr?.addressLine2 ??
                    ''}`
                ),
                formatDiff(oldAddr?.city, newAddr?.city),
                formatDiff(oldAddr?.state, newAddr?.state),
                formatDiff(oldAddr?.district, newAddr?.district),
                formatDiff(oldAddr?.postalCode, newAddr?.postalCode),
                formatDiff(oldAddr?.country, newAddr?.country),
              ]}
            />
          );
        })}
      </Container>
    </div>
  );
};
